<div class="highlight">
	<div class="highlight_title">{{statBlock.stat}}</div>
	<div class="highlight_subtitle">{{statBlock.subtext}}</div>
	<div class="highlight_footer">
		<a ng-href="{{statBlock.buttonLink}}" class="btn btn-default btn-lg btn-block" ng-disabled="statBlock.stat === 0">{{statBlock.buttonText}}</a>
	</div>
</div>